import {atom, DefaultValue, selector} from 'recoil';

const userUsernameState = atom({
  key: 'user_form_username',
  default: '',
});

const userEmailState = atom({
  key: 'user_form_email',
  default: '',
});

const userPasswordState = atom({
  key: 'user_form_password',
  default: '',
});

const userCompanyState = atom({
  key: 'user_form_company',
  default: '',
});

const userFirstnameState = atom({
  key: 'user_form_firstname',
  default: '',
});

const userLastnameState = atom({
  key: 'user_form_lastname',
  default: '',
});

const userFormAddressState = atom({
  key: 'user_form_address',
  default: '',
});

const userFormCityState = atom({
  key: 'user_form_city',
  default: '',
});

const userFormCountryState = atom({
  key: 'user_form_country',
  default: '',
});

const userFormZipCodeState = atom({
  key: 'user_form_zip_code',
  default: '',
});

const userFormBiographyState = atom({
  key: 'user_form_biography',
  default: '',
});

const userFormLoadingState = atom({
  key: 'user_form_loading',
  default: true,
});

const userFormSavingState = atom({
  key: 'user_form_saving',
  default: false,
});

const userFormErrorState = atom({
  key: 'user_form_Error',
  default: '',
});

const userFormState = selector({
  key: 'userEditForm',
  get: ({get}) => {
    // get values from individual atoms:
    const username = get(userUsernameState);
    const email = get(userEmailState);
    const password = get(userPasswordState);
    const company = get(userCompanyState);
    const firstname = get(userFirstnameState);
    const lastname = get(userLastnameState);
    const address = get(userFormAddressState);
    const city = get(userFormCityState);
    const country = get(userFormCountryState);
    const zipCode = get(userFormZipCodeState);
    const biography = get(userFormBiographyState);
    const saving = get(userFormSavingState);
    const loading = get(userFormLoadingState);
    const error = get(userFormErrorState);
    return {
      username, email, password, company, firstname, lastname,
      address, city, country, zipCode, biography, saving, loading, error
    };
  },
  set: ({set}, value) => {
    if (value instanceof DefaultValue) {
      set(userUsernameState, value);
      set(userEmailState, value);
      set(userPasswordState, value);
      set(userCompanyState, value);
      set(userFirstnameState, value);
      set(userLastnameState, value);
      set(userFormAddressState, value);
      set(userFormCityState, value);
      set(userFormCountryState, value);
      set(userFormZipCodeState, value);
      set(userFormBiographyState, value);
      set(userFormSavingState, value);
      set(userFormErrorState, value);
      set(userFormLoadingState, value);
      return;
    }
    set(userUsernameState, value.username);
    set(userEmailState, value.email);
    set(userPasswordState, value.password);
    set(userCompanyState, value.company);
    set(userFirstnameState, value.firstname);
    set(userLastnameState, value.lastname);
    set(userFormAddressState, value.address);
    set(userFormCityState, value.city);
    set(userFormCountryState, value.country);
    set(userFormZipCodeState, value.zipCode);
    set(userFormBiographyState, value.biography);
    set(userFormSavingState, value.saving);
    set(userFormLoadingState, value.loading);
    set(userFormErrorState, value.error);
  },
});

export {userFormState}